var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIxMaintenanceWarning = function SvgIxMaintenanceWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 1.667c4.595 0 8.333 3.738 8.333 8.333S14.595 18.333 10 18.333 1.667 14.595 1.667 10 5.405 1.667 10 1.667m0 1.666A6.657 6.657 0 0 0 3.333 10 6.657 6.657 0 0 0 10 16.667 6.66 6.66 0 0 0 16.667 10 6.657 6.657 0 0 0 10 3.333m.036 2.843c.63.82.843 1.828.64 2.564q-.037.183 2.666 2.834.885.885 0 1.768-.833.831-1.664.098l-2.924-2.776c-.737.202-1.745-.011-2.564-.641-.602-.79-.809-1.824-.641-2.565L6.83 8.74l1.282-.64.64-1.283-1.281-1.282c.74-.167 1.773.04 2.564.641",
    clipRule: "evenodd"
  })));
};
export default SvgIxMaintenanceWarning;